import { nextTick, shallowRef } from 'vue'

const OVERLAY_TARGET_SELECTOR = '#alkokh-overlay-target'

/**
 * The live `#alkokh-overlay-target` element, for overlays mounted ABOVE the layout (in `App.vue`).
 *
 * ⚠️ WHY A REF AND NOT THE `attach` STRING. Vuetify resolves `attach: '#alkokh-overlay-target'` in a
 * `computed` with no reactive input, so it is cached for the life of the overlay. Page dialogs are
 * re-created with the layout and never notice. App-level dialogs outlive it: the layout re-mounts
 * across the 960px shell switch and on default↔blank, and they kept teleporting into the detached
 * old node — opening invisibly. Passing this ref as `:attach` changes the prop, which re-runs that
 * computed. `undefined` (no target yet) falls back to the global default in `plugins/vuetify/defaults.ts`.
 */
export const overlayTargetEl = shallowRef<HTMLElement | undefined>()

/**
 * Function ref for the target `<div>` in the layouts. On unmount the replacement layout may already
 * be mounted (or not yet), so re-query after the patch rather than trusting call order.
 */
export function bindOverlayTarget(el: unknown) {
  if (el instanceof HTMLElement) {
    overlayTargetEl.value = el

    return
  }

  void nextTick(() => {
    overlayTargetEl.value = document.querySelector<HTMLElement>(OVERLAY_TARGET_SELECTOR) ?? undefined
  })
}
